import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class DriftValidators {
  static unique(existingValues: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value && existingValues.includes(value)) {
        return { nonUnique: true };
      }
      return null;
    };
  }
}
